import styled, { css } from 'styled-components'

export const StyledWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 0;
    & > div {
        flex: 1;
    }
    ${({ noMargin }) =>
        noMargin &&
        css`
          margin: 0;
        `
    };
`